import { gql, TypedDocumentNode } from '@apollo/client'

import { MutationInputError } from './types'

export const ERROR_FRAGMENT: TypedDocumentNode<MutationInputError> = gql`
  fragment ErrorFragment on Error {
    attribute
    message
  }
`
